<template>
  <div class="h-steps" :class="{'last-current':status==1}">
    <img class="steps-icon" :src="currentStep.src" alt />
    <div :style="{backgroundColor:currentStep.color}" class="line"></div>
    <span class="title">{{title}}</span>
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    type: {
      type: Number,
      default: 0
    },
    status: {
      type: Number,
      default: 0
    },
    title: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      currentStep: {},
      steps: [
        [
          {
            src: "/steps/icon_未完成 拷贝 2.png",
            color: "#E8E8E8"
          },
          {
            src: "/steps/icon_橘色_进行中.png",
            color: "#e48d27"
          },
          {
            src: "/steps/icon_橘色_完成.png",
            color: "#e48d27"
          }
        ],
        [
          {
            src: "/steps/icon_未完成 拷贝 2.png",
            color: "#E8E8E8"
          },
          {
            src: "/steps/icon_黄色_进行.png",
            color: "#E4DE83"
          },
          {
            src: "/steps/icon_黄色_完成.png",
            color: "#E4DE83"
          }
        ],
        [
          {
            src: "/steps/icon_未完成 拷贝 2.png",
            color: "#E8E8E8"
          },
          {
            src: "/steps/icon_绿色_进行中.png",
            color: "#79C489"
          },
          {
            src: "/steps/icon_绿色_完成.png",
            color: "#79C489"
          }
        ],
        [
          {
            src: "/steps/icon_未完成 拷贝 2.png",
            color: "#E8E8E8"
          },
          {
            src: "/steps/icon_蓝色_进行中.png",
            color: "#3E7FFF"
          },
          {
            src: "/steps/icon_蓝色_完成.png",
            color: "#3E7FFF"
          }
        ]
      ]
    };
  },
  created() {
    this.currentStep = this.steps[this.type][this.status];
  },
  methods: {}
};
</script>

<style lang="scss" scoped>
.h-steps {
  position: relative;
  width: 7.9%;
  height: 50px;
  //   overflow: hidden;
  float: left;
  &.last-current {
    .line {
      background: #e8e8e8 !important;
    }
  }
  .title {
    position: absolute;
    top: 30px;
    width: 70px;
    text-align: center;
    display: inline-block;
    left: 20%;
    margin-left: -22px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 400;
    color: rgba(102, 102, 102, 1);
  }
  .line {
    height: 2px;
    width: 100%;
    position: absolute;
    top: 12px;
    left: 27%;
    background: #e4be83;
  }
  .steps-icon {
    position: absolute;
    top: 0;
    left: 20%;
    z-index: 10;
  }
  .tab1 {
  }
}
.h-steps:last-child {
  width: 40px;
  .line {
    display: none;
  }
}
</style>